<template>
  <v-container fluid grid-list-md>
    <v-layout>
      <v-flex xs12>
        <v-flex>
          <v-card>
            <v-card-title primary-title class="headline">
              {{$t('network-settings')}}
              <v-spacer></v-spacer>
              <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
            </v-card-title>
            <!--<v-card-text>
              <v-text-field
                v-model="network.hostname"
                label="Hostname"
                required></v-text-field>
            </v-card-text>-->
            <v-tabs icons-and-text dark grow>
              <!--<v-tab>
                Cablata
                <v-icon>computer</v-icon>
              </v-tab>
              <v-tab-item>
                <v-container fluid grid-list-md>
                  <network-settings-eth0></network-settings-eth0>
                </v-container>
              </v-tab-item>-->
              <v-tab>
                Wireless
                <v-icon>wifi</v-icon>
              </v-tab>
              <v-tab-item>
                <v-container fluid grid-list-md>
                  <network-settings-wlan0></network-settings-wlan0>
                </v-container>
              </v-tab-item>
              <v-tab>
                WPS
                <v-icon>compare_arrows</v-icon>
              </v-tab>
              <v-tab-item>
                <v-container fluid grid-list-md>
                  <network-wifi-connect-wps></network-wifi-connect-wps>
                </v-container>
              </v-tab-item>
            </v-tabs>
            <v-card-actions>
              <v-btn flat @click="save">Save</v-btn>
              <v-btn flat>Default</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
//import NetworkSettingsEth0 from '@/components/NetworkSettingsEth0.vue'
import NetworkSettingsWlan0 from '@/components/NetworkSettingsWlan0.vue'
import NetworkWifiConnectWps from '@/components/NetworkWifiConnectWps.vue'

export default {
  name: "NetworkSettings",
  components: {
    //NetworkSettingsEth0,
    NetworkSettingsWlan0,
    NetworkWifiConnectWps
  },
  mounted() {
    this.fetchSettings();
  },
  computed: {
    ...mapGetters(["network", "loading"])
  },  
  methods: {
    fetchSettings() {
      this.$store.dispatch("fetchNetwork");
    },
    save() {
      this.$store.dispatch("saveNetwork");
    },
    restartNetwork() {
      this.$store.dispatch("restartNetwork");
    },
    restartNetworkStatus() {
      this.$store.dispatch("restartNetworkStatus");
    }


  }
};
</script>